export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-light-c141bb9093a2485e56a1e152e8aaed78.woff2";